import { setShowInvoiceModal } from '../State/showInvoiceModal'

export default () => async (dispatch) => {

  dispatch(setShowInvoiceModal(false))

}